import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { selectAffiliateData } from '#modules/auth/selectors/profile';
import useStyles from './styles';

const PeContentAffiliate: FC = () => {
  const data = useSelector(selectAffiliateData);

  const avatarUrl = data.imageUrl;

  const { affiliateIcons, affiliateLeftIcon, affiliateRightIcon, affiliateLogo, affiliateLogoContent } = useStyles({
    avatarUrl,
  });

  return (
    <div className={affiliateIcons}>
      <div className={affiliateLeftIcon} />
      <div className={affiliateLogo}>{!avatarUrl && <div className={affiliateLogoContent}>{data.name}</div>}</div>
      <div className={affiliateRightIcon} />
    </div>
  );
};

export default PeContentAffiliate;
